import AbstractProvidedClass from "../../shared/AbstractProvidedClass";
import { addSvg, createRowButton } from "../../shared/utils";

export default class RowHelper extends AbstractProvidedClass {
    constructor(provider, row) {
        super(provider);

        this.rowObject = row;
    }

    createOptions(options) {
        this.rowObject.options = this.p.createDiv()
            .parent(this.rowObject.row);
        this.rowObject.optionsContainer = this.p.createDiv()
            .parent(this.rowObject.options)
            .class('row');

        this.rowObject.options.hide();

        this.rowObject.buttons = {};
        options.forEach(option => this.rowObject.buttons[option] = this.createOption(option));
    }

    createOption(option) {
        let createButton = (tooltip, func, svgId) => {
            return createRowButton(this.p, this.rowObject.optionsContainer, tooltip, func, svgId);
        }
        switch (option) {
            case 'plant':
                return createButton('Plant', () => this.rowObject.place(), 'plant-line');

            case 'draw':
                return createButton('Draw into shape', () => this.rowObject.drawShape(), 'shape-line');

            case 'add':
                return createButton('Add to element', () => this.rowObject.addToElement(), 'add-line');

            case 'addToSelection':
                return createButton('Add to selection', () => this.rowObject.addToSelection(), 'add-line');

            case 'remove':
                return createButton('Remove', () => this.rowObject.remove(), 'close-circle-line');

            case 'edit':
                return createButton('Edit', () => this.rowObject.toggleEdit(), 'edit-line');

            case 'show':
                return createButton('Show', () => this.rowObject.toggleVisibility(), 'eye-line');

            case 'hide':
                return createButton('Hide', () => this.rowObject.toggleVisibility(), 'eye-off-line');

            case 'info':
                return this.createInfoButton();
        }
    }

    createInfoButton() {
        let btn = this.p.createA(this.rowObject.species['link'], '', '_blank')
            .parent(this.rowObject.optionsContainer)
            .class('btn-icon mar-l-xs')
            .attribute('data-tooltip', 'Profile')
        addSvg(btn, 'information-line');
        return btn;
    }
}
